import {MerchantCircle} from "@/entity/MerchantCircle";
import {Base} from "@/dto/Base";
import {RemoveEmptyUtils} from "pansx-utils/src/index";
import {KeyWords} from "@/entity/KeyWords";

export class MerchantCircleDto {
    public static url = '/merchantCircle';

    public static async findById(id: number): Promise<MerchantCircle> {
        const response = await Base.getDataWithJwt(this.url + '/byId', {id});
        const qTree = response as MerchantCircle;
        return qTree;
    }

    public static async findAll(qTree: MerchantCircle): Promise<MerchantCircle[]> {
        RemoveEmptyUtils.removeEmptyString(qTree);
        RemoveEmptyUtils.removeZero(qTree);
        const response = await Base.getDataWithJwt<MerchantCircle[]>(this.url + '/all', qTree);
        const qTreeList = response as MerchantCircle[];
        return qTreeList;
    }

    public static async finAllQTree(): Promise<MerchantCircle[]> {
        const response = await Base.getDataWithJwt(this.url + '/finAllQTree')
        const qTreeList = response as MerchantCircle[]
        return qTreeList
    }

    public static async findChildQTree(qTree: MerchantCircle): Promise<MerchantCircle | unknown> {
        const response = await Base.postWithToken(this.url + '/findChildQTree', qTree)
        const jieGuo = response
        return jieGuo
    }

    public static async accurateSelectQTree(): Promise<MerchantCircle[]> {
        const response = await Base.getDataWithJwt(this.url + '/accurateSelectQTree')
        const jieguo = response as MerchantCircle[]
        return jieguo
    }

    public static async allPage(
        qTree: MerchantCircle,
        pagination: Pagination,
    ): Promise<Page<MerchantCircle>> {
        RemoveEmptyUtils.removeEmptyString(qTree);
        RemoveEmptyUtils.removeZero(qTree);
        const response = await Base.findAllPage(
            this.url + '/allPage',
            pagination,
            qTree,
        );
        return response as Page<MerchantCircle>;
    }

    public static async delete(id: number) {
        await Base.getDataWithJwt(this.url + '/delete', {id});
    }

    public static async save(qTree: MerchantCircle): Promise<MerchantCircle> {
        const response = await Base.postWithToken(this.url + '/save', qTree);
        return MerchantCircle.of(response);
    }

    public static async saveNewComments(qTree: MerchantCircle): Promise<MerchantCircle> {
        const response = await Base.postWithToken(this.url + '/saveNewComments', qTree)
        return MerchantCircle.of(response)
    }

    public static async getKeyWords(): Promise<KeyWords[]> {
        const keyWords = await Base.getDataWithJwt('/mongdb/getKeyWords') as KeyWords[];
        return keyWords;
    }
}
